<template>
  <div
    class="c-breadcrumbs">
    <router-link
      class="c-breadcrumbs__home"
      to="/">
      <HomeIcon class="c-breadcrumbs__home" />
    </router-link>
    <div v-if="crumbs.length"
      class="c-breadcrumbs__wrapper">
      <div v-for="(item, i) in crumbs"
        :key="`${item.slug}-${i}`"
        class="c-breadcrumbs__crumb">
        <router-link v-if="i < crumbs.length - 1"
          :to="`/${item.type}/${item.slug}`"
          class="c-breadcrumbs__link">
          <span v-if="item.index" class="c-breadcrumbs__index">
            {{ item.index }}
          </span>
          <span class="c-breadcrumbs__item">
            {{ item.name }}
          </span>
        </router-link>

        <span v-else class="c-breadcrumbs__item">
          <span v-if="item.index" class="c-breadcrumbs__index">
            {{ item.index }}
          </span>
          {{ item.name }}
        </span>
      </div>
    </div>

    <ContentLoader v-else class="c-breadcrumbs__wrapper" height="20">
      <rect x="1rem" y="0rem" width="100%" height="1rem"></rect>
    </ContentLoader>
  </div>
</template>

<script>
import HomeIcon from './assets/svg/HomeIcon'
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    HomeIcon,
    ContentLoader
  },

  props: {
    crumbs: Array
  }
}
</script>

<style lang="scss">
.c-breadcrumbs {
  line-height: 1rem;
  font-size: 0.85rem;
  display: flex;
}
.c-breadcrumbs__home {
  height: 1rem;
}
.c-breadcrumbs__crumb {
  &:before {
    content: "/";
    margin: 0 .25rem 0 .5rem;
    vertical-align: top;
    text-decoration: none !important;
  }
}
.c-breadcrumbs__link {
  text-decoration: none;
}
.c-breadcrumbs__item {
  margin: 0 0 0 .05rem;
}
.c-breadcrumbs__wrapper {
  height: 1rem;
  display: flex;
}
</style>
